import React from 'react'
import { useEmployeeFinanaceDetails } from '../../../Hooks/Features/EmployeeFinance/useEmployeeFinanaceDetails'
import { AgGridReact } from '@ag-grid-community/react'
import { SkeletonDataTable } from '../../../components/Loader/Loader'
import UserFinanace from './UserFinanace'

const EmployeeFinanaceDetails = () => {

    const { columnDefs, rowData, showPopUp, setShowPopUp } = useEmployeeFinanaceDetails()
    return (
        <div className='py-2'>
            <div className='d-flex justify-content-between'>
                <h5>
                    Employee Finanace Information
                </h5>
                <div>
                    <button className='btn-primary' onClick={() => setShowPopUp(true)}>+ Add</button>
                </div>
            </div>
            {
                false ? <SkeletonDataTable numSkeletons={10} /> :
                    <>
                        {
                            <div className='estimate-grid'>
                                <div className="ag-theme-alpine aggrid-container" style={{ height: 'calc(100vh - 70px)' }}>
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rowData}
                                        rowHeight={30}
                                        headerHeight={30}
                                    />
                                </div>
                            </div>
                        }
                    </>
            }
            <UserFinanace showPopUp={showPopUp} setShowPopUp={setShowPopUp} />

        </div>
    )
}

export default EmployeeFinanaceDetails